import React from 'react'
import {Box, Typography} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

// New-style equivalent of src/components/templates/TherapyDialogs/Stepper.tsx — not a components-new
// system component, just composed with base MUI layout elements per page-level convention.

interface Step {
  key: string
  title: string
}

interface StepProgressProps {
  steps: Step[]
  currentStep: number
}

export default function StepProgress({steps, currentStep}: StepProgressProps): JSX.Element {
  const theme = useTheme()
  const nextStep = steps[currentStep + 1]

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, mb: 2}}>
      <Typography sx={{fontSize: 16, color: theme.palette.primary.main}}>
        {`Step ${currentStep + 1} di ${steps.length} `}
        <Box component="span" sx={{fontWeight: 700}}>{steps[currentStep]?.title}</Box>
      </Typography>
      <Box sx={{display: 'flex', gap: 0.5}}>
        {steps.map((step, index) => (
          <Box
            key={step.key}
            sx={{
              width: 40,
              height: 4,
              borderRadius: '2px',
              backgroundColor: index <= currentStep ? theme.palette.primary.main : NEUTRAL_SCALE[300],
            }}
          />
        ))}
      </Box>
      {nextStep && (
        <Typography variant="caption" sx={{color: NEUTRAL_SCALE[500]}}>
          {`Prossimo step: ${nextStep.title}`}
        </Typography>
      )}
    </Box>
  )
}
